import { isDevRosterAuthRequired } from './devRosterAuth';
import { isPersonalModelPilotSlug } from '../utils/resolvePersonalModelSlug';

export type KryspaceReadSource = 'db' | 'workspace';

/** Thin-read source query param: roster JWT sessions use db authZ; legacy dev uses workspace. */
export function resolveKryspaceReadSource(opts?: {
  hasAuthToken?: boolean;
  /** Person-scope pilot slugs always use workspace (no companies.kryspace_slug row). */
  workspaceSlug?: string;
}): KryspaceReadSource {
  if (isPersonalModelPilotSlug(opts?.workspaceSlug)) {
    return 'workspace';
  }

  const hasToken =
    opts?.hasAuthToken ??
    (typeof localStorage !== 'undefined' && Boolean(localStorage.getItem('token')));

  if (process.env.NODE_ENV === 'production') {
    return hasToken ? 'db' : 'workspace';
  }

  if (!isDevRosterAuthRequired()) {
    return 'workspace';
  }

  return hasToken ? 'db' : 'workspace';
}

export const SELECTED_COMPANY_KRYSPACE_SLUG_KEY = 'selectedCompanyKryspaceSlug';
